import React, { Component } from 'react';
import { connect } from 'react-redux';
import { requestRooms, receiveRoom, setRoom } from '../store/actions/roomActions';

class ChatRoomList extends Component {

    constructor() {
        super()
        this.state = {
            activeRoom: 0
        }
    }

    componentDidMount() {

        this.props.onRequestRooms();

        this.props.connection.on(
            "NewRoom",
            (roomName, roomId) => {
                this.props.onReceiveRoom(
                    roomName,
                    roomId
                )
            }
        )
    }


    changeSlide(roomid) {
        var x = this.props.rooms.find((element) => {
            return element.id === roomid;
        });

        if (x != null) {
            x.newMessagesCount = 0;
        }
            

        this.setState({
            activeRoom: roomid
        });
    }

    render() {
        var qs = require('qs');
        const clientId = qs.parse(window.location.search, { ignoreQueryPrefix: true }).clientid    
  
        return (
            <div className={clientId ? "rooms-list-gone" : "rooms-list"}>
                <div className='rooms-list-header'><h4>Chat</h4></div>
                <ul>
                    {this.props.rooms.map(room => {

                        return (
                            <li key={room.id} className={this.state.activeRoom !== room.id ? 'room' : 'room-active'} onClick={() => { this.props.onSetRoom(room); this.changeSlide(room.id) }} href="#active">
                                <span className='rooms-list-text'>
                                    {room.name}
                                </span>
                                {room.newMessagesCount > 0 ? (<div className='rooms-newmessagescount'> {room.newMessagesCount} </div>) : ''}
                            </li>
                        )
                    })}
                </ul>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        rooms: state.requestRooms.rooms,
        currentRoom: state.requestRooms.currentRoom
    }
}

const mapDispatchToProps = (dispatch) => {
    var qs = require('qs');
    const clientId = qs.parse(window.location.search, { ignoreQueryPrefix: true }).clientid
    const apotheekId = qs.parse(window.location.search, { ignoreQueryPrefix: true }).ovisapotheekid;
    return {
        onRequestRooms: () => dispatch(requestRooms(clientId, apotheekId)),
        onReceiveRoom: (
            roomName,
            id
        ) =>
            dispatch(
                receiveRoom(
                    roomName,
                    id
                )
            ),
        onSetRoom: (room) => dispatch(setRoom(room))
    }
}

export default connect(mapStateToProps, mapDispatchToProps, this.props)(ChatRoomList);


// WEBPACK FOOTER //
// ./src/components/ChatRoomList.js